import { c as _c } from "react/compiler-runtime";
import React from "react";
import Markdown from "react-markdown";
import rehypeExternalLinks from "rehype-external-links";
import rehypeSanitize from "rehype-sanitize";
import remarkGfm from "remark-gfm";
interface AgreementStepAgreementProps {
  readonly text: string;
}

/**
 * A component that renders markdown text in a scrollable container.
 * Used for displaying legal agreements, terms, and other formatted text.
 */
export default function AgreementStepAgreement(t0) {
  const $ = _c(5);
  const {
    text
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [[rehypeExternalLinks, {
      target: "_blank",
      rel: ["noopener", "noreferrer", "nofollow"],
      protocols: ["http", "https"]
    }], [rehypeSanitize]];
    t2 = [remarkGfm];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      h1: _temp,
      h2: _temp2,
      h3: _temp3,
      p: _temp4,
      ul: _temp5,
      ol: _temp6,
      li: _temp7,
      a: _temp8,
      blockquote: _temp9,
      code: _temp10,
      pre: _temp11
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== text) {
    t4 = <div className="tw-w-full tw-flex tw-flex-col tw-items-center"><div className="tw-w-full tw-border tw-border-iron-800 tw-rounded-lg tw-overflow-y-auto tw-overflow-x-hidden tw-p-4 tw-max-h-[50vh] md:tw-max-h-[60vh] lg:tw-min-h-[20vh] tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800"><Markdown rehypePlugins={t1} remarkPlugins={t2} className="tw-text-iron-200 tw-w-full" components={t3}>{text}</Markdown></div></div>;
    $[3] = text;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp11(t0) {
  const {
    children: children_9
  } = t0;
  return <pre className="tw-bg-iron-800 tw-rounded tw-p-3 tw-overflow-x-auto tw-my-3 tw-font-mono tw-text-sm">{children_9}</pre>;
}
function _temp10(t0) {
  const {
    children: children_8
  } = t0;
  return <code className="tw-bg-iron-800 tw-rounded tw-px-1 tw-py-0.5 tw-font-mono tw-text-sm">{children_8}</code>;
}
function _temp9(t0) {
  const {
    children: children_7
  } = t0;
  return <blockquote className="tw-border-l-4 tw-border-iron-500 tw-pl-4 tw-italic tw-my-3">{children_7}</blockquote>;
}
function _temp8(t0) {
  const {
    href,
    children: children_6
  } = t0;
  return <a href={href} target="_blank" rel="nofollow noopener noreferrer" className="tw-text-blue-400 hover:tw-text-blue-300 tw-underline">{children_6}</a>;
}
function _temp7(t0) {
  const {
    children: children_5
  } = t0;
  return <li className="tw-text-iron-300 tw-mb-1">{children_5}</li>;
}
function _temp6(t0) {
  const {
    children: children_4
  } = t0;
  return <ol className="tw-list-decimal tw-pl-6 tw-mb-3">{children_4}</ol>;
}
function _temp5(t0) {
  const {
    children: children_3
  } = t0;
  return <ul className="tw-list-disc tw-pl-6 tw-mb-3">{children_3}</ul>;
}
function _temp4(t0) {
  const {
    children: children_2
  } = t0;
  return <p className="tw-text-iron-300 tw-mb-3 tw-leading-relaxed tw-whitespace-pre-wrap tw-break-words">{children_2}</p>;
}
function _temp3(t0) {
  const {
    children: children_1
  } = t0;
  return <h3 className="tw-text-lg tw-font-semibold tw-text-iron-100 tw-mt-3 tw-mb-1">{children_1}</h3>;
}
function _temp2(t0) {
  const {
    children: children_0
  } = t0;
  return <h2 className="tw-text-xl tw-font-semibold tw-text-iron-100 tw-mt-3 tw-mb-2">{children_0}</h2>;
}
function _temp(t0) {
  const {
    children
  } = t0;
  return <h1 className="tw-text-2xl tw-font-semibold tw-text-iron-100 tw-mt-4 tw-mb-2">{children}</h1>;
}